import Splide from '@splidejs/splide';

export default class RecipeHead extends HTMLElement {

    constructor() {
        super();
        this.carousels = this.querySelectorAll('.splide');
        this.mainCarousel = this.carousels[0];
        this.thumbnailsCarousel = this.carousels[this.carousels.length - 1];
    }

    connectedCallback() {
        let main = new Splide( this.mainCarousel, {
            type      : 'slide',
            pagination: false,
            arrows    : true,
            heightRatio: 1
        });


        main.sync( thumbnails );
        main.mount();
        thumbnails.mount();
    }

}